module.exports = __webpack_public_path__ + "img/820-82f75d.png";